export default __webpack_public_path__ + "static/media/job_offer11_l.5eceea35.jpg";